import React from 'react';
import {ColumnHeaderSortable} from '../../DataTable/index.jsx';
import Column from './base.jsx';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from "react-bootstrap/Popover";

var columnOptions = {
    id: 'col-risk',
    title: 'Risk'
};
let id = 0;

class HeaderColumn extends ColumnHeaderSortable {
    get id() {
        return columnOptions.id;
    }

    get title() {
        return columnOptions.title;
    }

    get overlayText() {
        return "Collective Shift's Risk rating of cryptocurrencies";
    }
}


class DetailColumn extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: id++
        };
    }

    overlay() {
        return (
            <Popover id={"popover-positioned-" + this.state.id} className={"p-2 cs-text pre-line"}>
                {this.props.row.indicatortext}
            </Popover>
        );
    }

    render() {
        let popup, btnclass;
        const assetRisk= {
            1 :'Neutral',
            2 :'Low',
            3 :'Moderate',
            4 :'High',
            5 :'Extreme',
        }
        switch(this.props.row.risk) {
            case 1:
                btnclass = 'btn-neutral'
                break
            case 2:
                btnclass = 'btn-info'
                break
            case 3:
                btnclass = 'btn-bad'
                break
            case 4:
                btnclass = 'btn-very-bad'
                break
            case 5:
                btnclass = 'btn-very-very-bad'
                break
        }

        if (this.props.row.risk && this.props.row.upgradeurl === '') {
            popup = <OverlayTrigger overlay={this.overlay()} trigger="focus" placement="auto">
                            <button
                                className={`btn btn-sm btn-block text-nowrap ${btnclass}`}
                                role="button"
                            >
                                {assetRisk[this.props.row.risk]}
                            </button>
                        </OverlayTrigger>
        } else if (this.props.row.upgradeurl !== '') {
            popup = <a href={this.props.row.upgradeurl} className="btn btn-sm btn-block btn-primary">Upgrade</a>
        } else {
            popup = ''
        }
        return (
            <td>
                {popup}
            </td>
        );
    }
}


class Risk extends Column {
    get id() {
        return columnOptions.id;
    }

    get title() {
        return columnOptions.title;
    }

    sortAscending(a, b) {
        if (! a.risk) {
            return 1;
        }
        if (! b.risk) {
            return -1;
        }
        if (a.risk < b.risk) {
            return -1;
        }
        if (a.risk > b.risk) {
            return 1;
        }
        return super.sortAscending(a, b);
    }

    sortDescending(a, b) {
        if (! a.risk) {
            return 1;
        }
        if (! b.risk) {
            return -1;
        }
        if (a.risk < b.risk) {
            return 1;
        }
        if (a.risk > b.risk) {
            return -1;
        }
        return super.sortDescending(a, b);
    }

    get DetailColumn() {
        return DetailColumn;
    }

    get HeaderColumn() {
        return HeaderColumn;
    }
}


export default Risk;

